import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";
import { LABS } from "@/data/content";
import { FlaskConical, Crosshair, Globe, Radar } from "lucide-react";

const ICONS = { FlaskConical, Crosshair, Globe, Radar };

export const Labs = () => (
    <section id="labs" data-testid="labs-section" className="scroll-mt-20 border-t border-white/5 bg-surface/30 py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeader
                chapter="04"
                kicker="Hands-On"
                title="Cybersecurity Labs"
                testId="labs-heading"
            />

            <Reveal className="-mt-8 mb-12 md:-mt-12 md:mb-16">
                <span
                    data-testid="labs-training-badge"
                    className="inline-flex items-center gap-2 border border-cyber/40 bg-cyber/5 px-4 py-2 font-mono2 text-xs uppercase tracking-[0.2em] text-cyber"
                >
                    <span className="h-1.5 w-1.5 rounded-full bg-cyber" />
                    Training / Labs — Controlled Learning Environments
                </span>
            </Reveal>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {LABS.map((lab, i) => {
                    const Icon = ICONS[lab.icon];
                    return (
                        <Reveal key={lab.title} delay={i * 0.1}>
                            <article
                                data-testid={`lab-card-${lab.title.toLowerCase().replace(/\s+/g, "-")}`}
                                className="group h-full border border-white/10 bg-surface/70 p-7 transition-[border-color,box-shadow] duration-500 hover:border-cyber/40 hover:shadow-[0_0_28px_rgba(0,240,255,0.08)]"
                            >
                                <span className="mb-6 flex h-11 w-11 items-center justify-center border border-cyber/30 bg-cyber/5 text-cyber">
                                    <Icon size={19} strokeWidth={1.5} />
                                </span>
                                <h3 className="font-display text-lg font-bold tracking-tight text-zinc-100">
                                    {lab.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                                    {lab.text}
                                </p>
                                <p className="mt-5 font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-600">
                                    Training / Labs
                                </p>
                            </article>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
